/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Auto_FormatInputs */



/**
* | output |
* | --- |
* | "Auto Format Text" |
*
* @param {Context_Menu_Auto_FormatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_auto_format = /** @type {((inputs?: Context_Menu_Auto_FormatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Auto_FormatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mise en forme auto du texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text automatisch formatieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formattazione automatica del testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое форматирование текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato automático de texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动格式化文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストの自動フォーマット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट को स्वचालित रूप से फॉर्मेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatação automática de texto")
	return /** @type {LocalizedString} */ ("Auto Format Text")
});